import { createFileRoute } from "@tanstack/react-router";
import AdminLeads from "@/pages/admin/AdminLeads";

export const Route = createFileRoute("/admin/leads")({
  validateSearch: (search: Record<string, unknown>): { origen?: string | undefined } => ({
    origen: typeof search["origen"] === "string" ? (search["origen"] as string) : undefined,
  }),
  component: AdminLeads,
});
